import React, {useState} from 'react'
import {
  styled,
  TextField as MuiTextField,
} from '@material-ui/core'
import {useEditApplication} from 'lms/hooks'

const CHAR_LIMIT = 300

const Content = styled('div')(({theme}) => ({
  marginTop: theme.spacing(1),
}))

const Description = (props) => {
  const [application, updateApplication] = useEditApplication()
  const [charCount, setCharCount] = useState(application.description?.length || 0)

  const remaining = CHAR_LIMIT - charCount

  return (
    <Content {...props}>
      <MuiTextField
        defaultValue={application.description}
        onChange={(e) => {
          setCharCount(e.target.value.length)
          updateApplication({description: e.target.value})
        }}
        label="Description"
        variant="outlined"
        multiline
        maxRows={12}
        fullWidth
        inputProps={{maxLength: CHAR_LIMIT}}
        helperText={`${remaining} of ${CHAR_LIMIT} characters remaining`}
        FormHelperTextProps={{style: {color: remaining <= 0 ? '#f44336' : undefined}}}
      />
    </Content>
  )
}

export default Description
